var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/ui/components/timeline.tsx";
const _excluded = ["timelineId", "onLoadMore", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { OrderedSet as ImmutableOrderedSet } from 'immutable';
import debounce from 'lodash/debounce';
import React, { useCallback, useMemo, useRef } from 'react';
import { createPortal } from 'react-dom';
import { defineMessages } from 'react-intl';
import { dequeueTimeline, scrollTopTimeline } from 'soapbox/actions/timelines';
import ScrollToButton from 'soapbox/components/scroll-to-button';
import StatusList from 'soapbox/components/status_list';
import { useAppSelector, useAppDispatch } from 'soapbox/hooks';
import { makeGetStatusIds } from 'soapbox/selectors';
const messages = defineMessages({
  queue: {
    "id": "status_list.queue_label",
    "defaultMessage": "Click to see {count} new {count, plural, one {post} other {posts}}"
  }
});
const getStatusIds = makeGetStatusIds();

/** Scrollable list of statuses from a timeline in the Redux store. */
const Timeline = _ref => {
  let {
      timelineId,
      onLoadMore,
      children
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const dispatch = useAppDispatch();
  const lastStatusId = useAppSelector(state => (state.timelines.get(timelineId)?.items || ImmutableOrderedSet()).last());
  const statusIds = useAppSelector(state => getStatusIds(state, {
    type: timelineId
  }));
  const isLoading = useAppSelector(state => (state.timelines.get(timelineId) || {
    isLoading: true
  }).isLoading === true);
  const isPartial = useAppSelector(state => (state.timelines.get(timelineId)?.isPartial || false) === true);
  const hasMore = useAppSelector(state => state.timelines.get(timelineId)?.hasMore === true);
  const totalQueuedItemsCount = useAppSelector(state => state.timelines.get(timelineId)?.totalQueuedItemsCount || 0);
  const isFilteringFeed = useAppSelector(state => !!state.timelines.get(timelineId)?.feedAccountId);
  const handleDequeueTimeline = useCallback(() => {
    if (isFilteringFeed) {
      return;
    }
    dispatch(dequeueTimeline(timelineId, onLoadMore));
  }, [dispatch, isFilteringFeed, onLoadMore, timelineId]);
  const handleScrollDebounced = useMemo(() => {
    return debounce(() => {
      dispatch(scrollTopTimeline(timelineId, false));
    }, 100);
  }, [dispatch, timelineId]);
  const handleScroll = useCallback(() => handleScrollDebounced(), [handleScrollDebounced]);
  const top = useRef(null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/createPortal(/*#__PURE__*/React.createElement(ScrollToButton, {
    key: "timeline-queue-button-header",
    onClick: handleDequeueTimeline,
    count: totalQueuedItemsCount,
    message: messages.queue,
    to: top,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 22
    }
  }), document.body), /*#__PURE__*/React.createElement("div", {
    ref: top,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(StatusList, _extends({
    timelineId: timelineId,
    onScroll: handleScroll,
    lastStatusId: lastStatusId,
    statusIds: statusIds,
    isLoading: isLoading,
    isPartial: isPartial,
    hasMore: hasMore,
    onLoadMore: onLoadMore
  }, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 7
    }
  }), children));
};
export default Timeline;